import FilterMode from "./FilterMode";
import Content from "./Content";

function DateFilters() {
    return (
        <div className="tw-flex tw-items-center">
            <FilterMode />
            <Content />
        </div>
    );
}

export default DateFilters;
